<template>
  <div class="main_right">
    <div class="Box">
      <div style="display: flex; gap: 10px; margin-bottom: 10px;">
        <el-select v-model="selectedType" placeholder="请先选择类型" style="width: 180px" clearable
                   @change="handleTypeChange">
          <el-option
              v-for="(item, index) in typeName"
              :key="index"
              :label="item.mc"
              :value="item.id"
          />
        </el-select>
        <el-select v-model="selectedVersion" placeholder="选择版本" style="width: 180px" clearable
                   :disabled="!selectedType" @change="handleVersionChange">
          <el-option
              v-for="(item, index) in versionList"
              :key="index"
              :label="item.bbmc"
              :value="item.bbid"
          />
        </el-select>
        <el-select v-model="selectedZ" placeholder="选择章" style="width: 180px" clearable
                   :disabled="!selectedVersion" @change="handleZChange">
          <el-option
              v-for="(item, index) in zList"
              :key="index"
              :label="item.zmc"
              :value="item.zid"
          />
        </el-select>
        <el-select v-model="selectedUnit" placeholder="选择单元" style="width: 180px" clearable :disabled="!selectedZ">
          <el-option
              v-for="(item, index) in unitList"
              :key="index"
              :label="item.mc"
              :value="item.id"
          />
        </el-select>
        <el-select v-model="ydlx" placeholder="选择文章类别" style="width: 180px;" clearable @change="resetQuery">
          <el-option label="议论文" value="议论文"></el-option>
          <el-option label="应用文" value="应用文"></el-option>
          <el-option label="记叙文" value="记叙文"></el-option>
        </el-select>
        <el-button icon="el-icon-search" size="mini" @click="searchChange">查 询</el-button>
      </div>
      <div class="testpage" style="height:calc(100% - 6.5vw);">
        <p>
          <span>课后阅读</span>
        </p>
        <el-table ref="table" class="table" :data="tableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
          <!-- 自定义序号 -->
          <el-table-column align="center" width="80" label="序号">
            <template v-slot="scope">
              {{ (pages.currentPage - 1) * pages.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="lxmc" label="类型" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="bbmc" label="版本" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="zmc" label="章" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="dymc" label="单元" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="ydlx" label="类别" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="ydnr" label="阅读内容" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <span>{{
                  scope.row.ydnr && scope.row.ydnr.length > 20 ? scope.row.ydnr.substring(0, 20) + '...' : scope.row.ydnr
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center"  width="150">
            <template slot-scope="scope">
                <span class="operation" @click="look(scope.row)">
                  查看文章
               </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination @size-change="stuHandleSizeChange" @current-change="stuHandleCurrentChange"
                       :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]"
                       :page-size="pages.pageSize" layout="total, sizes, prev, pager, next"
                       :total="pages.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="查看文章" :visible.sync="viewDialog.visible" width="60%" append-to-body>
      <div class="article-view">
        <h2>{{ viewDialog.ydlx }}文章</h2>
        <div class="article-meta">
          <span>类型: {{ viewDialog.lxmc }}</span>
          <span>版本: {{ viewDialog.bbmc }}</span>
          <span>章: {{ viewDialog.zmc }}</span>
          <span>单元: {{ viewDialog.dymc }}</span>
          <span>文章类别: {{ viewDialog.ydlx }}</span>
        </div>
        <div class="article-content">
          {{ viewDialog.ydnr }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialog.visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {wordArticle, getReviewLastType, getReviewLastBb, getReviewLastZ, getReviewLastUnit} from '@/api/student'

export default {
  data() {
    return {
      typeName: [],
      selectedType: '', // 选中类型
      versionList: [], // 版本列表
      selectedVersion: '', // 选中版本
      zList: [], // 章列表
      selectedZ: '', // 选中章
      unitList: [], // 单元列表
      selectedUnit: '', // 选中单元
      ydlx: '',// 文章类别
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 100
      },
      tableData: [],
      // 查看文章弹窗
      viewDialog: {
        visible: false,
        lxmc: '',
        bbmc: '',
        zmc: '',
        dymc: '',
        ydlx: '',
        ydnr: ''
      },
    }
  },
  created() {
    this.getReview()
    getReviewLastType({
      bjid: this.$store.state.userInfo.bjid,
      yycdid: Number(sessionStorage.getItem('yycdid'))
    }).then(res => {
      if (res.success) {
        this.typeName = res.result
      } else {
        this.$message.error(res.resultDesc)
      }
    })
  },

  methods: {
    async handleTypeChange(value) {
      this.selectedVersion = ''
      this.selectedZ = ''
      this.versionList = []
      this.zList = []
      this.unitList = []
      if (value) {
        await this.getBz(value)
      }
    },
    async handleVersionChange(value) {
      this.selectedZ = ''
      this.zList = []
      if (value) {
        await this.getZ(value)
      }
    },
    async handleZChange(value) {
      this.selectedUnit = ''
      this.unitList = []
      if (value) {
        await this.getUnit(value)
      }
    },
    async getBz(lxid) {
      const res = await getReviewLastBb({
        bjid: this.$store.state.userInfo.bjid,
        lxid: lxid,
        yycdid: Number(sessionStorage.getItem('yycdid')),
      })
      if (res.success) {
        this.versionList = res.result
      } else {
        this.$message.error(res.resultDesc)
      }
    },
    async getZ(bbid) {
      const res = await getReviewLastZ({
        bbid: bbid,
        bjid: this.$store.state.userInfo.bjid,
        jxid: this.$store.state.userInfo.jxid,
        yycdid: Number(sessionStorage.getItem('yycdid')),
        xsid: this.$store.state.userInfo.yhid
      })
      if (res.success) {
        this.zList = res.result
      } else {
        this.$message.error(res.resultDesc)
      }
    },
    async getUnit(zid) {
      const res = await getReviewLastUnit({
        jxid: this.$store.state.userInfo.jxid,
        xsid: this.$store.state.userInfo.yhid,
        zid: zid
      })
      if (res.success) {
        this.unitList = res.result
      } else {
        this.$message.error(res.resultDesc)
      }
    },

    look(row) {
      this.viewDialog = {
        visible: true,
        lxmc: row.lxmc,
        bbmc: row.bbmc,
        zmc: row.zmc,
        dymc: row.dymc,
        ydlx: row.ydlx,
        ydnr: row.ydnr
      };
    },
    searchChange() {
      this.getReview()
    },
    resetQuery() {
      this.getReview()
    },
    // 获取熟词信息
    async getReview() {
      const params = {
        currentPage: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        ydlx: this.ydlx,
      }

      if (this.selectedType) {
        params.lxid = this.selectedType
      }
      if (this.selectedVersion) {
        params.bbid = this.selectedVersion
      }
      if (this.selectedZ) {
        params.zid = this.selectedZ
      }
      if (this.selectedUnit) {
        params.dyid = this.selectedUnit
      }
      const {resultCode, result: {list, total}} = await wordArticle(params)
      if (resultCode === 200) {
        this.tableData = list
        this.pages.total = total
      }
    },
    stuHandleSizeChange(val) {
      this.pages.pageSize = val;
      this.pages.currentPage = 1;
      this.getReview()
    },
    stuHandleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getReview()
    },
  },
  watch: {
    selectedVersion() {
      this.pages.currentPage = 1
      this.getReview()
    },
    selectedZ() {
      this.pages.currentPage = 1
      this.getReview()
    },
    selectedUnit() {
      this.pages.currentPage = 1
      this.getReview()
    }
  }
}
</script>
<style lang="scss" scoped>

.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;
}

.article-view {
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }

  .article-meta {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .article-content {
    line-height: 1.8;
    white-space: pre-wrap;
  }
}

.page {
  position: absolute;
  bottom: 10px;
  right: 0;
}

.Box {
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
  border-radius: 10px;
  padding: 2%;
  box-sizing: border-box;
  position: relative;

  .select {
    height: 2.5vw;
    width: 47vw;
    // background: #5990ff;
    background: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
    padding: 0.25vw;
    margin-bottom: 1vw;

    p {
      float: right;
      width: 50%;
      height: 100%;
      background: #f1f8ff;
      font-size: 1vw;
      color: #333;
      text-align: center;
      line-height: 2vw;
      border: 1px solid rgb(220, 223, 230);
      border-radius: 4px;
    }
  }
}

.vocabulary {
  width: 30%;
  height: 3vw;
  float: left;

  div {
    width: 14vw;
    height: 3vw;
    background: #f1f8ff;
    border-radius: 10px;
    line-height: 3vw;
    box-sizing: border-box;
    padding: 0 3%;
    color: #333;

    span {
      display: block;
    }

    span:nth-child(1) {
      // display: block;
      font-size: 1.1vw;
      float: left;
    }

    p {
      float: right;

      span:nth-child(1) {
        font-size: 1.5vw;
        color: #409eff;
        font-weight: 600;
        float: left;
        margin-right: 1.5vw;
      }

      span:nth-child(2) {
        font-size: 1vw;
        float: left;
      }
    }
  }
}

.testpage {
  width: 100%;
  position: relative;

  p:nth-child(1) {
    width: 100%;
    height: 2.5vw;
    text-align: center;
    position: relative;
    color: #333;
    font-size: 1.5vw;
    line-height: 2.5vw;
  }
}

.table {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 1vw;
  top: 4vw;
}

.aRow {
  width: 100%;
  height: 3vw;
}

.aRow:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.operation {
  display: inline-block;
  line-height: 2vw;
  width: 5vw;
  height: 2vw;
  font-size: 0.8vw;
  background: #e0eaff;
  box-shadow: 0px 0px 7px 1px rgba(89, 144, 255, 0.3);
  border-radius: 21px;
  color: #5990ff;
  cursor: pointer;
}


.selsectbox {
  width: 130px;
  // background: #fff;
  background: #f1f8ff;
  border-radius: 4px;
}

.exitpopup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2004;
}

.viewRresults {
  width: 30vw;
  height: 14.5vw;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  z-index: 2004;

  .title {
    width: 100%;
    height: 3vw;
    background: #5990ff;
    border-radius: 10px 10px 0 0;
    color: #fff;
    font-size: 1.3vw;
    text-align: center;
    line-height: 3vw;
  }

  .body {
    width: 100%;
    height: 8vw;
    box-sizing: border-box;
    padding: 1vw;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .box {
      width: 30%;
      height: 100%;
      background: #eaf0fc;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      padding-top: 1vw;
      position: relative;

      p:nth-child(2) {
        position: absolute;
        top: 3.5vw;
        font-size: 1.1vw;
      }

      p:nth-child(1) {
        font-size: 1.7vw;
      }
    }
  }

  .footer {
    width: 100%;
    height: 3vw;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      width: 8vw;
      height: 2.3vw;
      background: #5990ff;
      border-radius: 25px;
      color: #fff;
      font-size: 1.2vw;
      text-align: center;
      line-height: 2.3vw;
      cursor: pointer;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2001;
}

::v-deep  .selsectbox .el-input--small .el-input__inner {
  // background-color: #e6f0ff;
  padding-left: 40px;
  height: 50px;
  border-radius: 5px;
  // color: #1890FF;
  font-size: 18px;
  border: 1px solid #1890ff;
  font-weight: 600;
}

::v-deep  .selsectbox .el-icon-arrow-up::before {
  content: "";
  background: url("../../../assets/images/student/triangle.png") center center no-repeat;
  position: absolute;
  background-size: 18px 12px;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(180deg);
}

::v-deep  .selsectbox .el-input--small input::-webkit-input-placeholder {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  // color: #2881FF;
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;

    .Box {
      padding: 12px 10px;
      display: flex;
      flex-direction: column;
      height: auto;
      min-height: 100%;

      > div:first-child {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 15px;

        .el-select {
          width: 100% !important;
          margin: 0 !important;

          ::v-deep  .el-input__inner {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
          }
        }

        .el-button {
          width: 100%;
          height: 40px;
          margin: 0;
        }
      }
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;

      p:nth-child(1) {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        flex-shrink: 0;
        text-align: center;
      }

      .table {
        position: relative;
        top: auto;
        bottom: auto;
        flex: 1;
        overflow: auto;
        width: 100%;

        ::v-deep  .el-table__body-wrapper {
          overflow-x: auto;
        }

        ::v-deep  .el-table__header {
          width: 100%;
        }

        ::v-deep  .el-table__body {
          width: 100%;
        }
      }
    }

    .page {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 15px;
      display: flex;
      justify-content: flex-end;

      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 8px;
        }

        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }

        .el-pagination__total {
          font-size: 12px;
        }

        .el-pagination__sizes {
          .el-select .el-input__inner {
            font-size: 12px;
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }

    .operation {
      width: 70px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
    }
  }

  .article-view {
    h2 {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .article-meta {
      flex-wrap: wrap;
      gap: 8px;
      font-size: 12px;

      span {
        margin-right: 8px;
      }
    }

    .article-content {
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .Box {
      padding: 10px 8px;

      > div:first-child {
        gap: 8px;

        .el-select ::v-deep  .el-input__inner {
          height: 36px;
          font-size: 12px;
        }

        .el-button {
          height: 36px;
          font-size: 12px;
        }
      }
    }

    .testpage p:nth-child(1) {
      height: 32px;
      line-height: 32px;
      font-size: 13px;
    }

    .page {
      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 6px;
          min-width: 28px;
        }

        .el-pager li {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 11px;
        }

        .el-pagination__total {
          font-size: 11px;
        }

        .el-pagination__sizes .el-select .el-input__inner {
          font-size: 11px;
          height: 24px;
          line-height: 24px;
        }
      }
    }

    .operation {
      width: 60px;
      height: 28px;
      line-height: 28px;
      font-size: 11px;
    }
  }

  .article-view {
    h2 {
      font-size: 16px;
    }

    .article-meta {
      font-size: 11px;
    }

    .article-content {
      font-size: 13px;
    }
  }
}
</style>
<style lang="scss">
@media screen and (max-width: 768px) {
  .el-dialog {
    width: 90% !important;
    max-width: 500px;

    .el-dialog__header {
      padding: 15px 20px 10px;
    }

    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
    }
  }
}
</style>
